/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React, { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Plx from 'react-plx';

import { Grid, Typography } from '@mui/material';

import { Namespaces } from '../../../../i18n';
import { createServicesSectionStyles } from './ServicesSection.styles';

const parallaxData = [
  {
    start: '.plxServicesBlock',
    duration: '40vh',
    properties: [
      {
        startValue: -40,
        endValue: 0,
        unit: 'vh',
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: 1,
        property: 'opacity',
      },
    ],
  },
];

export const ServicesSection = memo(() => {
  const classes = createServicesSectionStyles();
  const { i18n, t } = useTranslation(Namespaces.About);
  const links = [
    `https://www.cybertec-postgresql.com/${i18n.language}/products/cybertec-migrator/`,
    `https://www.cybertec-postgresql.com/${i18n.language}/products/cybertec-postgresql-enterprise-edition`,
    `https://www.cybertec-postgresql.com/${i18n.language}/services/postgresql-support/`,
    `https://www.cybertec-postgresql.com/${i18n.language}/services/postgresql-consulting/`,
    `https://www.cybertec-postgresql.com/${i18n.language}/courses/`,
  ];

  return (
    <div className={classes.root}>
      <Plx className={cx('plxServicesBlock', classes.plxServicesBlock)} parallaxData={parallaxData}>
        <Grid container classes={{ root: classes.container }}>
          <Typography variant="h1" classes={{ h1: classes.title }}>
            {t('services.title')}
          </Typography>
        </Grid>
        <div className={classes.container}>
          <Grid container spacing={5}>
            {links.map((link, i) => {
              return (
                <Grid item key={i} md={6}>
                  <a href={link} target={'blank'} className={cx(classes.card, classes.cardLink)}>
                    <Typography variant="h2" classes={{ h2: classes.cardTitle }}>
                      {t(`services.service_title_${i + 1}`)}
                    </Typography>
                    <Typography variant="body1" classes={{ root: classes.cardText }}>
                      <Trans>{t(`services.service_text_${i + 1}`)}</Trans>
                    </Typography>
                  </a>
                </Grid>
              );
            })}

            <Grid item md={6}>
              <div className={cx(classes.card, classes.cardNoLink)}>
                <Typography variant="h2" classes={{ root: classes.cardTitle }}>
                  {t('services.service_title_6')}
                </Typography>
                <Typography variant={'body1'} classes={{ root: classes.cardText }}>
                  <Trans>{t('services.service_text_6')}</Trans>
                </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
      </Plx>
    </div>
  );
});
